import React, { useEffect } from 'react';

import OnLoader from '@refere/ui-utils/ui/components/OnLoader';
import AppRoot from '@refere/ui-utils/ui/components/AppRoot';

import SeguroPage from './pages/seguro';
import CertificadoPage from './pages/certificado';

import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    RouterProvider,
  } from "react-router-dom";
import { useHookstate } from '@hookstate/core';

import { setErrorCallBack } from '@refere/ui-utils/ui/utils/fetch';
import { theme } from "@refere/ui-utils/ui/styles/StylesGlobal"
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

import { init } from './features/app';
import { globalState } from './features/global-state';

const nonceTag = document.getElementById("nonce") as HTMLInputElement;
const nonce = nonceTag.value;
const cache = createCache({
    key: 'refere-sistema',
    nonce,
    prepend: true,
  });

export const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path="/" element={<OnLoader />} />
            <Route path="seguro" element={<SeguroPage />} />
            <Route path="certificado" element={<CertificadoPage />} />
        </>
    )
  );

const App = () => {
    const isLoading = useHookstate(globalState.isLoading)

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        init();
    }, []);

    return (
        <CacheProvider value={cache}>
            <AppRoot
                setFetchErrorCallBack={setErrorCallBack}
                isLoading={isLoading.get()}
                theme={theme}
            >
                <RouterProvider router={router} />
            </AppRoot>
        </CacheProvider>
    );
}

export default App;

